export function newSyngooConfiguracao() {
    return {
        agente_integracao_token: null,
        channel_id: null,
        company_id: 0,
        dashboard_link_permanente: null,
    };
}
